import { useCallback, useState } from 'react';

const KEY = 'dashboard.fbcOnlyMyTerritories';

// FBC-only picker preference. When true (the default) the franchisee picker is
// scoped to the FBC's own assigned territories; when false the FBC can browse
// and open every franchisee in the network. Persisted in localStorage so the
// choice survives reloads, and defaults to true when unset — an FBC lands on
// their own portfolio and opts into the network-wide view deliberately.
function read(): boolean {
  if (typeof window === 'undefined') return true;
  try {
    const v = window.localStorage.getItem(KEY);
    return v === null ? true : v === '1';
  } catch {
    return true;
  }
}

export function useTerritoryScope(): [boolean, (next: boolean) => void] {
  const [onlyMine, setOnlyMine] = useState<boolean>(read);

  const update = useCallback((next: boolean) => {
    try {
      window.localStorage.setItem(KEY, next ? '1' : '0');
    } catch {
      // ignore (private mode etc.)
    }
    setOnlyMine(next);
  }, []);

  return [onlyMine, update];
}
